import React from 'react';
import { IoMdReturnLeft } from "react-icons/io";
interface SidebarOpenProps{
    onClick: ()=>void;
}
const SidebarOpen: React.FC<SidebarOpenProps> = ({onClick}) => {
    return (
        <div onClick={onClick} className='fixed bottom-20 left-20 bg-green-600 hover:cursor-pointer hover:bg-green-700 transition ease-in tra px-2 z-50 py-1 rounded-r-full shadow-lg hidden lg:block'>
            <div className="rounded-sm transform text-gray-100 ">
                <IoMdReturnLeft />
            </div>
        </div>
    );
};

export default SidebarOpen;
